import { WithContext as ReactTags, SEPARATORS } from 'react-tag-input';

import styles from './InputTags.module.scss';

const InputTags = (props) => {
  return (
    <ReactTags
      {...props}
      placeholder="Paste one or more IPs"
      separators={[
        SEPARATORS.ENTER,
        SEPARATORS.COMMA,
        SEPARATORS.SEMICOLON,
        SEPARATORS.SPACE,
        SEPARATORS.TAB,
      ]}
      inputFieldPosition="inline"
      editable
      autoFocus={false}
      classNames={{
        tags: styles['ReactTags__tags'],
        tagInputField: styles['ReactTags__tagInputField'],
        selected: styles['ReactTags__selected'],
        tag: styles['ReactTags__tag'],
        remove: `ReactTags__remove ${styles['remove']}`,
        editTagInput: styles['ReactTags__tagInput'],
      }}
    />
  );
};

export default InputTags;
